module.exports = __webpack_public_path__ + "img/6-disabled.be402bf2.png";